import PublicLayout from '../../components/PublicLayout'
import { Link } from '@inertiajs/react'

function formatCurrency(amount) {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount || 0)
}

export default function OrderSuccess({ order, store }) {
  return (
    <PublicLayout title={store.activity_name}>
      <div className="max-w-md mx-auto text-center space-y-6">
        <div>
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Beställning lagd!</h1>
          <p className="text-gray-500 mt-2">
            Tack, {order.customer_name}!{' '}
            Vi hör av oss på {[order.customer_email, order.customer_phone].filter(Boolean).join(' eller ')}.
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100 text-left">
          {order.items.map((item, i) => (
            <div key={i} className="flex justify-between px-4 py-3">
              <span className="text-gray-900">{item.name} × {item.quantity}</span>
              <span className="font-medium">{formatCurrency(item.subtotal)}</span>
            </div>
          ))}
          <div className="flex justify-between px-4 py-3 font-bold text-gray-900">
            <span>Totalt</span>
            <span>{formatCurrency(order.total)}</span>
          </div>
        </div>

        <Link
          href={`/stores/${store.token}`}
          className="inline-block text-indigo-600 hover:underline text-sm"
        >
          ← Tillbaka till butiken
        </Link>
      </div>
    </PublicLayout>
  )
}
